import TherapistForm from './TherapistForm'
export default TherapistForm
